import { useNavigate } from "react-router-dom";
import { ArrowForward as ArrowForwardIcon } from "../../_app/components/icons";
import { withWidget } from "./components/Widget";
import { useGetBalance, useGetOverdue } from "../../billing/hooks";
import { formatNumber } from "../../_app/utils/format";
import { createStylesheet } from "../../_app/utils/styles";
import { UIButton, UICard, UITypography } from "../../_app/components";

type Props = {
  hasManage?: boolean;
};

const BalanceOverdue = ({ hasManage = true }: Props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { data: balance, isFetching } = useGetBalance();
  const { data: overdue, isFetching: isFetchingOver } = useGetOverdue();

  return (
    <UICard isFetching={isFetching || isFetchingOver} className={classes.ctr}>
      <div className={classes.contentWrap}>
        <UITypography variant="h3">Balance / Overdue</UITypography>

        <div className={classes.middle}>
          <div className={classes.value}>
            <UITypography variant="h2">{formatNumber(balance || 0, 2, "£")}</UITypography>
            <UITypography variant="h2">
              &nbsp;&nbsp;/&nbsp;&nbsp;
              {formatNumber(overdue || 0, 2, "£")}
            </UITypography>
          </div>
        </div>

        {hasManage && (
          <div className={classes.footer}>
            <UIButton
              className="widget-button"
              color="primary"
              variant="contained"
              onClick={() => navigate("/statements")}
              endIcon={<ArrowForwardIcon />}
            >
              View
            </UIButton>
          </div>
        )}
      </div>
    </UICard>
  );
};

const useStyles = createStylesheet(() => ({
  ctr: {
    height: "100%",
  },
  contentWrap: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  middle: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  value: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-start",
  },
}));

export default withWidget(BalanceOverdue, "balance-overdue");
